import DOMPurify from 'dompurify';
import { Container } from 'react-bootstrap';
import logo from '../components/Nav/assets/Sidebar_Logo_Open.png';

const TermsAndConditions = ({ data }) => {
  const sanitizedTermsToRender = DOMPurify.sanitize(data.page);
  return (
    <Container fluid>
      <div className="d-flex justify-content-center justify-content-md-start">
        <img
          className="w-75 w-md-25 ratio-1x1"
          style={{ maxHeight: '10%', maxWidth: '10%' }}
          src={logo}
        />
      </div>
      <div
        className="d-flex flex-column justify-content-center text-center align-items-center mb-2 p-2 h-lg h-lg-xl"
        style={{ minHeight: '80vh' }}
      >
        <h1>Terms of Use</h1>
        <p>This Terms of Use Policy was last modified on {data.date}</p>
        <a href="/" className="text-white">
          Return to home
        </a>
        <div className="overflow-auto text-start d-flex mt-4 p-3 flex-column customScrollbar-Y">
          <div
            className="html-content"
            dangerouslySetInnerHTML={{ __html: sanitizedTermsToRender }}
          />
        </div>
      </div>
    </Container>
  );
};

export default TermsAndConditions;
